import { z } from 'zod';
import { NodeTypeSchema, NodeFieldTypeSchema } from './node-types.schema';

/**
 * Node Configuration Schemas
 * Defines the structure and fields for each node type
 */

// Node field configuration
export const NodeFieldSchema = z.object({
  label: z.string(),
  type: NodeFieldTypeSchema,
  placeholder: z.string().optional(),
  required: z.boolean().optional(),
  active: z.boolean().optional(),
});

// Parent-child relationship configuration
export const NodeParentConfigSchema = z.object({
  canBeParent: z.boolean().optional().default(true),      // Can this node type have children?
  canHaveParent: z.boolean().optional().default(true),    // Can this node type be a child?
  maxChildren: z.number().optional(),                      // Max children limit (unlimited by default)
  allowedChildTypes: z.array(z.string()).optional(),      // Allowed child node types (any by default)
});

// Complete node configuration
export const NodeConfigSchema = z.object({
  type: NodeTypeSchema,
  title: z.string(),
  icon: z.string(),
  fields: z.array(NodeFieldSchema),
  parentConfig: NodeParentConfigSchema.optional(),        // Parent-child configuration
});

// TypeScript types (with proper optionals)
export type NodeField = {
  label: string;
  type: z.infer<typeof NodeFieldTypeSchema>;
  placeholder?: string;
  required?: boolean;
  active?: boolean;
};

export type NodeParentConfig = z.infer<typeof NodeParentConfigSchema>;

export type NodeConfig = {
  type: z.infer<typeof NodeTypeSchema>;
  title: string;
  icon: string;
  fields: NodeField[];
  parentConfig?: NodeParentConfig;
};
